import { Component, OnInit, Input } from '@angular/core'
import { Observable, of } from 'rxjs'
import { User, AuthService } from '@spartacus/core'
import { QuoteDataService } from '../../../quote-checkout/services/quote-data.service'
import { QuoteCheckoutService } from '../../../quote-checkout/services/quote-checkout.service'
import { QuoteCartService } from '../../../quote-services/quote-cart.service'
import { Router } from '@angular/router'
import { QuoteReviewService } from '../../services/quote-review.service'
import { switchMap } from 'rxjs/operators'
import { UserAccountFacade } from '@spartacus/user/account/root'

@Component({
  standalone: false,
  selector: 'vs-review-notification-attachments',
  templateUrl: './review-notification-attachments.component.html',
  styleUrls: ['./review-notification-attachments.component.scss'],
})
export class ReviewNotificationAttachmentsComponent implements OnInit {
  isLoggedIn = false
  reviewData: any
  complianceQuestionData: any
  isLoggedinUser = false
  public cartId
  public cartStatus
  public userType
  user$: Observable<User>
  loggedIn: boolean
  cartLoaded = false
  cartData: any
  cartData$: Observable<any>
  @Input() notificationEmail: any
  @Input() attachments: any
  @Input() contactNumber: any
  productData: any
  constructor(
    private quoteDataService: QuoteDataService,
    private quoteCheckoutService: QuoteCheckoutService,
    private quoteService: QuoteCartService,
    private auth: AuthService,

    private router: Router,
    private quoteReviewService: QuoteReviewService,
    private userAccountFacade: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.isLoggedinUser = success
        this.userType = 'current'
      } else {
        this.userType = 'anonymous'
      }
    })
    sessionStorage.setItem('notificationEmail', this.notificationEmail)
    // this.getCheckOutCartData();
  }
  getFileSize(fileSize) {
    if (Math.round((fileSize / 1024) * 1000) / 1000 >= 1024.0) {
      return (Math.round(fileSize / 1024) / 1024).toFixed(2) + ' mb'
    }
    if (Math.round((fileSize / 1024) * 1000) / 1000 < 1024.0) {
      return (Math.round((fileSize / 1024) * 1000) / 1000).toFixed() + ' kb'
    }
    // return (fileSize / (1024 * 1024)).toFixed(1) + ' mb';
  }
}
